import { render } from "./RecordingStatusLabel.vue?vue&type=template&id=33d68c9f&lang=html"
import script from "./RecordingStatusLabel.vue?vue&type=script&lang=js"
export * from "./RecordingStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__